import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { GetServerSidePropsContext } from 'next';
import { GetServerSidePropsResult } from 'next/types';
import React from 'react';
import { getDynamicPageData } from 'utils/getDynamicPageData';

import { DynamicPage } from 'components/CMS/DynamicPage';

const AboutUsLandingPage = ({ data, pageData }: DynamicPageData) => {
  return <DynamicPage data={data} pageData={pageData} />;
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<DynamicPageData>> {
  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.About_Us_Landing_Page, context);

  if (error) {
    return { notFound: true };
  }

  if (pageData?.redirect_url) {
    return {
      redirect: {
        destination: pageData.redirect_url,
        permanent: true,
      },
    };
  }

  return { props: { data: modules, pageData } };
}

export default AboutUsLandingPage;
